<button type="button" class="close"  (click)="modalRehide()" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>

<ngx-doc-viewer [url]="documentUrl" viewer="google" style="width:100%;height:50vh;"></ngx-doc-viewer>

